<template>
  <div>
    <div v-for="page in pages">
      <h3>{{ page.page.title }}</h3>
      <div class="list-view response__copy" v-if="Object.keys(page.page.fields).length > 0">
        <div class="list-view__header">
          <div>Question</div>
          <div>Answer</div>
        </div>
        <div class="list-view__row" v-for="(field, key) in sortedData(page.data, page.page.fields)">
          <div>{{ field.title }}</div>
          <div v-if="page.page.fields[field.ref].field_type === 'file'">
            <download-link :files="field.data" />
          </div>
          <div v-else class="preserve-whitespace">{{ field.data }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DownloadLink from '@/components/DownloadLink';

  export default {
    name: 'survey-response',

    props: ['pages'],

    components: { DownloadLink },

    methods: {
      sortedData(data, fields) {
        const sortedKeys = Object.keys(data).sort((a, b) => fields[a].position - fields[b].position);
        const sortedData = {};
        sortedKeys.forEach(key => sortedData[key] = data[key]);
        return sortedData;
      },
    },
  };
</script>
